//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/DebugSession.js";
let d=[[],[[[],"GetPartnavMode",{R_:{mode:''}},0,0],[["mode"],"SetPartnavMode",{},1,0],[["numFilters","filters"],"GetPartnavFilterSettings",{},0,0],[["filters"],"SetPartnavFilterSettings",{},1,0],[["numColumns","columns"],"GetPartnavColumnSettings",{},0,0],[["columns"],"SetPartnavColumnSettings",{},1,0],[[],"GetCurrentFilter",{R_:{activeFilter:''}},0,0],[["activeFilter"],"SetCurrentFilter",{},1,0],[[],"GetActiveFilterFlag",{R_:{activeFlag:''}},0,0],[["activeFlag"],"SetActiveFilterFlag",{},1,0],[[],"GetPartnavSortedColumnSetting",{R_:{sortedColumnString:''}},0,0],[["sortedColumnString"],"SetPartnavSortedColumnSetting",{},1,0],[[],"ResorePartnavColumnAndFilterSettings",{},0,0],[[],"GetFeatureCheckBoxPreference",{R_:{featureCheckBoxPref:''}},0,0],[["featureCheckBoxPref"],"SetFeatureCheckBoxPreference",{},1,0],[[],"GetShowExpressionsGroupPreference",{R_:{showExpressionsGroupPreference:''}},0,0],[["showExpressionsGroupPreference"],"SetShowExpressionsGroupPreference",{},1,0]],[]];
SPLM.PartnavDebugSession = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.PartnavDebugSession";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PartnavDebugSession.PartnavMode = Object.freeze({
    "TimeStamp" : "TimeStamp", "BodyView" : "BodyView"});

SPLM.PartnavDebugSession.FeatureCheckBoxPreference = Object.freeze({
    "Suppress" : "Suppress", "Hide" : "Hide"});

export default SPLM;